import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class MaterialsFactoryProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_MER_API)
  }

  getAll (query) {
    this.setHeader(getAuthToken())
    return this.get('/material-stores', query)
  }

  getById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/material-stores/${id}`)
  }

  createOne (form) {
    this.setHeader(getAuthToken())
    return this.post('/material-stores', form)
  }

  updateOne (id, form) {
    this.setHeader(getAuthToken())
    return this.put(`/material-stores/${id}`, form)
  }

  deleteOne (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/material-stores/${id}`)
  }
}

export default MaterialsFactoryProvider
